export var DEFAULT_LABELKEY = 'label';
export var SIZES = ['lg', 'sm'];